/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  FallbackProvider,
  JsonRpcProvider,
  JsonRpcSigner,
  decodeBase64,
  encodeBase64,
} from "ethers";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { useAccount, useDisconnect } from "wagmi";
import { Auth, AuthSignData } from "@/proto/common/common_pb";
import { useModalStore } from "@/store/modle";
import { CacheAddress } from "@/constants/const";

declare global {
  interface Window {
    // ethereum: any;
    web3: any;
    updateWeb3Modal: any;
  }
}

interface Web3ContextProps {
  auth: Auth | undefined;
  signer: JsonRpcSigner | undefined;
  provider: JsonRpcProvider | FallbackProvider | undefined;
  getAuth: (
    address: string,
    isSafe?: boolean,
    chainId?: number
  ) => Promise<void>;
  logout: () => void;
}

export const Web3Context = createContext<Web3ContextProps>({
  auth: undefined,
  signer: undefined,
  provider: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  getAuth: async (address: string, isSafe?: boolean, chainId?: number) => {},
  logout: () => {},
});

interface IProps {
  children: JSX.Element;
}

const effectiveTime = 30 * 24 * 60 * 60;
export const Web3ContextProvider = ({ children }: IProps) => {
  const [signer, setSigner] = useState<JsonRpcSigner>();
  const [provider, setProvider] = useState<
    JsonRpcProvider | FallbackProvider | undefined
  >();
  const [auth, setAuth] = useState<Auth>();
  const { address, isConnected } = useAccount();

  const { disconnect } = useDisconnect();
  const setScroll = useModalStore((state) => state.setScroll);

  const getAuth = async (tempAddress?: string, isSafe = false, chainId = 0) => {
    try {
      if (!tempAddress) return;

      setAuth(undefined);
      localStorage.setItem("auth", "");

      // const curTime = Math.floor(Date.now() / 1000);

      // const signData = new AuthSignData();
      // signData.setAddr(tempAddress.toLowerCase());
      // signData.setSignTime(curTime);
      // signData.setSafeChainId(isSafe ? chainId : 0);

      // const dashboardAuth = new Auth();
      // dashboardAuth.setSignData(signData);

      // setAuth(dashboardAuth);

      // localStorage.setItem(
      //   "auth",
      //   encodeBase64(dashboardAuth.serializeBinary())
      // );
      // localStorage.setItem(CacheAddress.cacheAddress, tempAddress);
      // setScroll(true);

      // console.log("Auth created:", dashboardAuth);
    } catch (error) {
      console.error("getAuth error:", error);
      localStorage.setItem("auth", "");
      localStorage.setItem(CacheAddress.cacheAddress, "");
      disconnect();
    }
  };

  // useEffect(() => {
  //   const reloadData = async () => {
  //     let cachedAuth;
  //     cachedAuth = localStorage.getItem(CacheAddress.cacheAddress);

  //     if (cachedAuth && cachedAuth !== "") {
  //       if (!address) {
  //         return;
  //       }
  //       try {
  //         // const currentProvider = await getEthersProvider(wagmiConfig);
  //         const dashboardAuth = Auth.deserializeBinary(
  //           decodeBase64(cachedAuth)
  //         );
  //         const cacheAddress = dashboardAuth?.getSignData()?.getAddr();
  //         const cacheTime = Number(
  //           dashboardAuth?.getSignData()?.getSignTime() || 0
  //         );
  //         const curTime1 = (new Date().getTime() / 1000).toFixed(0);
  //         const curTime = Number(curTime1);
  //         if (
  //           cacheTime === 0 ||
  //           curTime - cacheTime > effectiveTime ||
  //           (cacheAddress?.toLocaleLowerCase() ?? "") !==
  //             address.toLocaleLowerCase()
  //         ) {
  //           setAuth(undefined);
  //           logout();
  //           disconnect();
  //           // window.location.reload();
  //         } else {
  //           setTimeout(async () => {
  //             // const currentSigner = await getEthersSigner(wagmiConfig);
  //             // setSigner(currentSigner);
  //           }, 1000);
  //           setAuth(dashboardAuth);
  //           // setConnectSuccess(true);
  //           // setProvider(currentProvider);
  //         }
  //       } catch (error) {
  //         console.log("reloadAuthData error", error);
  //       }
  //     } else {
  //       console.log("auth empty", isConnected);
  //       logout();
  //     }
  //   };
  //   reloadData();
  // }, [address, isConnected]); // eslint-disable-line react-hooks/exhaustive-deps

  const logout = useCallback(async () => {
    localStorage.setItem("auth", "");
    // localStorage.setItem("decimals", "");
    // localStorage.setItem("symbol", "");
    setScroll(false);
  }, []);

  return (
    <Web3Context.Provider
      value={{
        auth,
        signer,
        provider,
        getAuth,
        logout,
      }}
    >
      {children}
    </Web3Context.Provider>
  );
};

export const useWeb3Context: () => Web3ContextProps = () =>
  useContext(Web3Context);
